<template>
  <v-dialog v-model="dialog" width="1000">
    <template v-slot:activator="{ on, attrs }">
      <v-btn text class="router-link-exact-active " v-bind="attrs" v-on="on">
        Privacy Policy
      </v-btn>
    </template>
    <v-card>
      <v-card-text>
        <img :src="require('@/assets/policy/ATRC Platform - Privacy Policy -1.png')" width="100%" />
        <img :src="require('@/assets/policy/ATRC Platform - Privacy Policy -2.png')" width="100%" />
        <img :src="require('@/assets/policy/ATRC Platform - Privacy Policy -3.png')" width="100%" />
        <img :src="require('@/assets/policy/ATRC Platform - Privacy Policy -4.png')" width="100%" />
        <img :src="require('@/assets/policy/ATRC Platform - Privacy Policy -5.png')" width="100%" />
        <img :src="require('@/assets/policy/ATRC Platform - Privacy Policy -6.png')" width="100%" />
        <img :src="require('@/assets/policy/ATRC Platform - Privacy Policy -7.png')" width="100%" />
        <img :src="require('@/assets/policy/ATRC Platform - Privacy Policy -8.png')" width="100%" />
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="dialog = false">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'PrivacyPolicyModal',
  data: () => ({
    dialog: false,
  }),
};
</script>
